import {ChevronDown} from 'lucide-react';
import {cn} from 'src/lib/utils';

type Props<T extends string> = {
  className?: string;
  options: T[];
  value: T;
  onChange: (value: T) => void;
  // Maps an option value to its display label; defaults to the value itself.
  getOptionLabel?: (value: T) => string;
};

export const Select = <T extends string>(props: Props<T>) => {
  const {className, options, value, onChange, getOptionLabel} = props;
  const label = getOptionLabel ? getOptionLabel(value) : value;

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    onChange(e.target.value as unknown as T);
  };

  return (
    <span
      className={cn(
        'has-focus:border-ring border-input has-focus:ring-ring/50 relative flex flex-row items-center gap-1 rounded-md border px-2 py-1 shadow-xs has-focus:ring-[3px]',
        className,
      )}
    >
      {label} <ChevronDown className="size-4" />
      <select
        className="absolute inset-0 size-full cursor-pointer opacity-0"
        value={value}
        onChange={handleChange}
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {getOptionLabel ? getOptionLabel(option) : option}
          </option>
        ))}
      </select>
    </span>
  );
};
